module.exports = __webpack_public_path__ + "static/report-8cc75eebfe5e19260227ea7c1894d15d.jpeg";